/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowGameDevelopmentWorkshopTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowGameDevelopmentWorkshop,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Create a Game!",
    "Game Development Awaits!",
    "Bring Your Ideas to Life!",
  ],
  title: "Game Development Workshop",
  description: "Organize a fun game development workshop.",
  longDescription:
    "Gather your friends for a creative game development workshop! Choose a date, decide on the type of game to develop, and plan activities for the session!",
  emoji: "🎮",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Woodworker,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Game Development Workshop",
          emoji: "🎮",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the game development workshop?",
          emoji: "📅",
          completeAction: {
            question: "Decide on game type to develop?",
            description:
              "What type of game should we create during the workshop?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What game types should we choose?",
                emoji: "🕹",
                completeAction: {
                  question: "Decide on tools needed?",
                  description: "What tools should we gather for development?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What tools should we bring?",
                      emoji: "💻",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Develop Some Fun!",
    outroDescription:
      "Your game development workshop plans are set! Enjoy the creativity!",
  },
};
